// Keep the debounce function and the modified rangeSlider library code from the previous response

// Modified function to initialize the "Show More" button behavior for elements within a specific container
// This function should be called on the initial page load (for the whole document)
// and then specifically on the facet containers that were updated via AJAX.
function initShowMoreButtons(container = document) {
  // Find all facet lists within the specified container
  const facetLists = container.querySelectorAll(".facets__list");

  facetLists.forEach((el) => {
    const showMoreButton = el.querySelector('.list-menu__show-more');

    // Check if the button exists and if the list has more than 4 children
    if (showMoreButton && el.childElementCount > 4) {
      // Prevent adding duplicate listeners if this function is accidentally called twice on the same element
      // Replacing innerHTML should prevent this for the replaced elements, but this adds robustness.
      if (!showMoreButton.dataset.showMoreInitialized) {
         showMoreButton.addEventListener("click", function() {
           // Toggle the class on the facet list element
           if (el.classList.toggle("facets__list-long")) {
             showMoreButton.innerText = "- Minder opties";
           } else {
             showMoreButton.innerText = "+ Meer opties";
           }
         });
         // Mark the button as having its listener initialized
         showMoreButton.dataset.showMoreInitialized = 'true';
      }
    } else if (showMoreButton && el.childElementCount <= 4) {
        // If the button exists but is no longer needed (<= 4 items), ensure it's hidden or removed.
        // Your CSS or server-rendered HTML should ideally handle this, but JS could hide it.
        // For now, we just ensure the listener isn't added if the condition isn't met.
        // If the button *should* be hidden/removed, ensure your server template does that.
    }
  });
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

// Nu ook op mobiel live feedback geven bij elke klik
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
// CRO FIX: Directe feedback + Submit voor Ratings/Prijzen
    facetForm.querySelectorAll('.facets__item a, .facets__item label:not(.facet-checkbox)').forEach(item => {
      item.addEventListener('click', (event) => {
        if (facetForm.id === 'FacetFiltersFormMobile') {
          // 1. Verwijder eerst 'active' van broertjes (voor het geval je van rating switcht)
          const parentList = item.closest('.facets__list');
          if (parentList) {
            parentList.querySelectorAll('.is-selected-loading').forEach(el => el.classList.remove('is-selected-loading'));
          }

          // 2. Voeg direct de 'loading/selected' class toe voor visuele bevestiging
          item.classList.add('is-selected-loading');

          // 3. Submit de boel
          setTimeout(() => {
            this.onSubmitHandler(event);
          }, 100);
        }
      });
    });

    // Add click handler for mobile "Bevestigen" button
    // Check for button inside form first
    const mobileSubmitButton = facetForm.querySelector('.facets-mobile-submit');
    if (mobileSubmitButton) {
      mobileSubmitButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.onSubmitHandler(event);
        const sidebar = document.getElementById('site-filters-sidebar');
        if (sidebar && sidebar.hide) {
          sidebar.hide();
        }
      });
    }

    // Use event delegation for button in sidebar footer (outside this element)
    const sidebar = this.closest('#site-filters-sidebar');
    if (sidebar) {
      sidebar.addEventListener('click', (event) => {
        if (event.target.closest('.sidebar__footer .facets-mobile-submit')) {
          event.preventDefault();
          // Create a synthetic event with target inside the form so onSubmitHandler works
          const syntheticEvent = {
            preventDefault: () => {},
            target: facetForm
          };
          this.onSubmitHandler(syntheticEvent);
          if (sidebar.hide) {
            sidebar.hide();
          }
        }
      });
    }

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('main-collection-product-grid').classList.add('loading');
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGrid(html);
        FacetFiltersForm.renderProductCount(html);
        // REMOVED: No unconditional call here
    });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGrid(html);
    FacetFiltersForm.renderProductCount(html);
     // REMOVED: No unconditional call here
  }

  static renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML;
    document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
    document.getElementById('CollectionProductGrid').querySelectorAll('template').forEach(elm=>{
      elm.closest('form')?.append(elm.content.cloneNode(true));
    })
  }

  static renderProductCount(html) {
    const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount');
    if ( countEl ) {
      document.querySelectorAll('#CollectionProductCount').forEach(elm=>{
        elm.innerHTML = countEl.innerHTML;
      });
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? ( element.dataset.index === jsFilter.dataset.index && ! element.hasAttribute('data-and-operator') ) : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex); // This is the facet that triggered the update

    facetsToRender.forEach((element) => {
      // Find the existing element on the page that corresponds to this updated facet
        const existingElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

        if (existingElement) {
             // Replacing innerHTML removes old elements and creates new ones.
             // For custom elements like <price-range> and <facet-remove> within this HTML,
             // their disconnectedCallback should run, then connectedCallback for the new ones.
            existingElement.innerHTML = element.innerHTML;

             // **Re-initialize custom elements (like PriceRange) within the replaced HTML**
             // This is necessary because connectedCallback might need a push or
             // to ensure the initialization logic runs consistently after innerHTML replacement.
             // Query for custom elements *within* the element whose HTML was just replaced.
            existingElement.querySelectorAll('price-range').forEach(priceRangeEl => {
                 // Call the initialization method if it exists
                if (typeof priceRangeEl.initializePriceRange === 'function') {
                   priceRangeEl.initializePriceRange();
                } else if (typeof priceRangeEl.connectedCallback === 'function') {
                    // Fallback to calling connectedCallback if initializePriceRange is not a public method
                    priceRangeEl.connectedCallback();
                }
            });
            // Re-initialize any other custom elements that might need it (like facet-remove, although its constructor might be enough)
            existingElement.querySelectorAll('facet-remove').forEach(facetRemoveEl => {
                 // For facet-remove, the constructor attaching the click listener on creation
                 // should be sufficient after innerHTML replaces the element. No extra step needed unless issues arise.
            });


            // *** IMPORTANT FIX: Re-initialize "Show More" buttons ONLY for THIS replaced facet ***
            initShowMoreButtons(existingElement); // Run the initialization function on the replaced container

        }

    });

     // The facet that triggered the update (countsToRender) was NOT replaced.
     // Its existing custom elements (<price-range>, <facet-remove>) and their listeners (including "Meer opties" if applicable)
     // from the initial page load or a previous update are still present and should still be working.
     // We must NOT run initShowMoreButtons(event.target.closest('.js-filter')) here as it would add a duplicate listener.


    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // REMOVED: Do NOT call facetsEventListeners() or initShowMoreButtons(document) here.
     // Listeners have already been initialized on initial load,
     // and selectively re-initialized above for the replaced facets.
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      if ( document.querySelector(selector) ) {
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const countElementSelectors = ['.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Keep the PriceRange custom element code as updated in the previous response,
// ensuring initialization is in connectedCallback and uses initializePriceRange(),
// and includes the disconnectedCallback for cleanup.
class PriceRange extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
        this.initializePriceRange();
  }

 initializePriceRange() {
    this.querySelectorAll('input')
        .forEach(element => {
            element.addEventListener('change', this.onRangeChange.bind(this));
            element.addEventListener('input', this.maxCheck.bind(this));
        });

    this.setMinAndMaxValues();

    const inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = this.querySelector('input[name="filter.v.price.lte"]');
    let inputTimer = null;

    const rangeSliderElm = this.querySelector('[data-js-price-range-slider]');

    if (rangeSliderElm) {
        // Check if already initialized to prevent duplicates if initializePriceRange is called manually
        if (rangeSliderElm.sliderInstance) {
             // Clean up old instance if needed before creating a new one
             if (typeof rangeSliderElm.sliderInstance.removeGlobalEventListeners === 'function') {
                 rangeSliderElm.sliderInstance.removeGlobalEventListeners();
             }
             rangeSliderElm.sliderInstance = null;
        }


        const slider = rangeSlider(rangeSliderElm, {
            min: Number(inputMin.getAttribute('min')),
            max: Number(inputMax.getAttribute('max')),
            value: [Number(inputMin.value) || Number(inputMin.getAttribute('placeholder')), Number(inputMax.value) || Number(inputMax.getAttribute('placeholder'))],
            onInput: values => {
                inputMin.value = `${values[0]}`;
                inputMax.value = `${values[1]}`;
                clearTimeout(inputTimer);
                inputTimer = setTimeout(() => {
                    const facetForm = this.closest('facet-filters-form');
                    if (facetForm) {
                        facetForm.onSubmitHandler({
                            target: inputMin,
                            preventDefault: () => {}
                        });
                        this.onRangeChange({ currentTarget: inputMin });
                        this.onRangeChange({ currentTarget: inputMax });

                    } else {
                        console.error("FacetFiltersForm not found for price range slider.");
                    }

                }, 500);
            }
        });

        rangeSliderElm.sliderInstance = slider;

        rangeSliderElm.addEventListener('pointerdown', (event) => {
            if (!rangeSliderElm.sliderInstance) return;

            const rect = rangeSliderElm.getBoundingClientRect();
            const isVertical = rangeSliderElm.classList.contains('range-slider') && rangeSliderElm.hasAttribute('data-vertical');

            const clickPosition = isVertical
                ? (event.clientY - rect.top) / rect.height
                : (event.clientX - rect.left) / rect.width;

            const minValue = Number(inputMin.getAttribute('min'));
            const maxValue = Number(inputMax.getAttribute('max'));

            const newValue = minValue + clickPosition * (maxValue - minValue);

            const currentMinValue = Number(inputMin.value);
            const currentMaxValue = Number(inputMax.value);

            const leftDistance = Math.abs(newValue - currentMinValue);
            const rightDistance = Math.abs(newValue - currentMaxValue);

            if (leftDistance < rightDistance) {
                rangeSliderElm.sliderInstance.value([newValue, currentMaxValue], true);
            } else {
                rangeSliderElm.sliderInstance.value([currentMinValue, newValue], true);
            }
        });
    }
 }


  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();

    const inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = this.querySelector('input[name="filter.v.price.lte"]');
    const rangeSliderElm = this.querySelector('[data-js-price-range-slider]');

    if (rangeSliderElm && rangeSliderElm.sliderInstance) {
        rangeSliderElm.sliderInstance.value([Number(inputMin.value), Number(inputMax.value)]);
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    const minValue = Number(minInput.value);
    const maxValue = Number(maxInput.value);

    const originalMin = Number(minInput.getAttribute('data-original-min') || minInput.getAttribute('min') || '0');
    const originalMax = Number(maxInput.getAttribute('data-original-max') || maxInput.getAttribute('max') || '100');


    if (!isNaN(maxValue)) minInput.setAttribute('max', maxValue.toString());
    else minInput.setAttribute('max', originalMax.toString());

    if (!isNaN(minValue)) maxInput.setAttribute('min', minValue.toString());
    else maxInput.setAttribute('min', originalMin.toString());


    if (minInput.value === '') maxInput.setAttribute('min', originalMin.toString());
    if (maxInput.value === '') minInput.setAttribute('max', originalMax.toString());

 }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (!isNaN(min) && !isNaN(value) && value < min) input.value = min;
    if (!isNaN(max) && !isNaN(value) && value > max) input.value = max;
  }

  maxCheck(object) {
    let max = parseInt(object.target.max);
    let value = parseInt(object.target.value);

    if (!isNaN(max) && !isNaN(value) && value > max) {
      object.target.value = max;
    }
  }

    disconnectedCallback() {
        const rangeSliderElm = this.querySelector('[data-js-price-range-slider]');
        if (rangeSliderElm && rangeSliderElm.sliderInstance && typeof rangeSliderElm.sliderInstance.removeGlobalEventListeners === 'function') {
             rangeSliderElm.sliderInstance.removeGlobalEventListeners();
             rangeSliderElm.sliderInstance = null;
        }
    }
}


customElements.define('price-range', PriceRange);


// *** INITIAL CALL ONLY ***
// Initialize "Show More" buttons for all facet lists on the initial page load
document.addEventListener("DOMContentLoaded", function() {
  initShowMoreButtons(document);
});